import {
  AdminInformationCard,
  NestedReturnReasonOption,
  TranslationOption,
} from './retailer.model';

export const translationOptionsToMap = (
  value: TranslationOption[] | { [k: string]: string } | undefined,
): { [k: string]: string } => {
  if (!value) return {};
  if (Array.isArray(value)) {
    return Object.fromEntries(value.map((obj: any) => [obj.key, obj.value]));
  }
  return value;
};

export const formatInformationCards = (
  cards: AdminInformationCard[] | undefined,
): AdminInformationCard[] => {
  if (!cards || !Array.isArray(cards)) return [];

  return cards.map((card) => ({
    ...card,
    headlineTranslations: translationOptionsToMap(card.headlineTranslations),
    contentTranslations: translationOptionsToMap(card.contentTranslations),
    linkTextTranslations: translationOptionsToMap(card.linkTextTranslations),
  }));
};

export const formatNestedReturnReasons = (
  reasons: NestedReturnReasonOption[] | undefined,
) => {
  if (!reasons || !Array.isArray(reasons)) return [];

  return reasons.map((reason) => {
    const formattedCategoryName = Array.isArray(reason.reasonCategoryPrettyName)
      ? Object.fromEntries(
          reason.reasonCategoryPrettyName.map((obj: any) => [
            obj.key,
            obj.value,
          ]),
        )
      : reason.reasonCategoryPrettyName;

    return {
      ...reason,
      reasonCategoryPrettyName: formattedCategoryName,
      subReasons: (reason.subReasons || []).map((subreason) => {
        const formattedPrettyName = Array.isArray(subreason.prettyName)
          ? Object.fromEntries(
              subreason.prettyName.map((obj: any) => [obj.key, obj.value]),
            )
          : subreason.prettyName;

        const formattedCommentPlaceholder = Array.isArray(
          subreason.commentPlaceholder,
        )
          ? Object.fromEntries(
              subreason.commentPlaceholder.map((obj: any) => [
                obj.key,
                obj.value,
              ]),
            )
          : subreason.commentPlaceholder;

        return {
          ...subreason,
          prettyName: formattedPrettyName,
          commentPlaceholder: formattedCommentPlaceholder,
        };
      }),
    };
  });
};
